import { SCRIPT_ID } from '../../config';

function doesDataExist(data = {}) {
	return Object.keys(data || {}).length > 0;
}

export function getCurrentScript() {
	// NOTE: in case currentScript doesn't have data attrs (dev mode or storybook)
	// we have to use it for element with ID
	const reactScript = doesDataExist(document.currentScript?.dataset)
		? document.currentScript
		: document.getElementById(SCRIPT_ID);

	return reactScript;
}
